import React, { Component } from 'react'
import Icon from "../../../../../../images/settings-icons/setting-daily-weight.png";
import { Accordion } from "./components/setting-accordion";
import { SaveButton } from "./components/save-button";
import styled from "styled-components";
import {Toggle} from './components/toggle'
import { updateAuxiliary } from "../../../../../../api";

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;

class UpdateDailyWeights extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dailyWeighInEnabled: this.props.dailyWeighInEnabled,
      expanded: false,
      disableSubmit: true,
      isSubmitting: false,
      show: false,
    }
  }

  handleChange = name => {
    this.setState({ 
      [name]: 1 - Number(this.state[name]),
      disableSubmit: (1 - Number(this.state[name]) ===  this.props.dailyWeighInEnabled)
     })
  }

  handlePanelChange = (event, expanded) => {
    this.setState({ expanded: expanded })
  }

  handleSubmit = () => {
    const data = {
      daily_weigh_in_enabled: this.state.dailyWeighInEnabled
    }
    this.setState({ isSubmitting: true })
    updateAuxiliary(this.props.userId, this.props.portalId, data).then((res) => { 
      setTimeout(() => {
        this.setState({ isSubmitting: false });
        this.props.openSnackbar('Setting has been updated', false);
        this.props.loadPortalAccount();
      }, 1000);
      console.log('successful update')
    }).catch((err) => {
      setTimeout(() => {
        this.setState({ isSubmitting: false });
        this.props.openSnackbar('Setting failed to update', true)
      }, 1000);
      console.log('failed update: ', err)
    });
  }

  render() {
    return (
      <Accordion
        show={this.state.show}
        setShow={(val) => this.setState({show: val})}  
        settingName="Log daily weights"
        // description="Use an average of your daily weights at check-in"
        icon={Icon}
        currentSetting={this.props.dailyWeighInEnabled ? 'On' : 'Off' }
        alternateColor
      >
        <>
          <p>Users can improve the accuracy of their check-ins by logging a weight every day. Only turn on if the user can stick to daily measurements.</p>
          <Toggle
            label="Log daily weights"
            checked={this.state.dailyWeighInEnabled === 1}
            onChange={this.handleChange}
            value="dailyWeighInEnabled"
          />
          <ButtonRow>
            <SaveButton
              onClick={this.handleSubmit}
              isLoading={this.state.isSubmitting}
              disabled={this.state.disableSubmit}
            />
          </ButtonRow>
        </>
      </Accordion>
    )
  }
}

export default UpdateDailyWeights;

